import React, { useState } from 'react';

// ProductEdit.js
function ProductEdit({ product, setEditingProductId, authToken, categoryList, typeList }) {
    const [productName, setProductName] = useState(product.productName);
    const [description, setDescription] = useState(product.description);
    const [categories, setCategories] = useState(product.categories);
    const [price, setPrice] = useState(product.price);
    const [type, setType] = useState(product.type);
    const [brouwer, setBrouwer] = useState(product.brouwer);
    const [errorMessage, setError] = useState(null);


    const saveProduct = () => {
        // Logic to save product changes
        product.productName = productName;
        product.description = description;
        product.categories = categories;
        product.price = price;
        product.type = type;
        product.brouwer = brouwer;

        try {
            storeProduct(product);
        }
        catch (error) {
            setError('There was a problem with your fetch operation:', error);
        }
        setError(null);
        alert('Product saved');

        // After saving, return to list view
        setEditingProductId(null);
    };

    const storeProduct = async (p) => {
        const url = process.env.REACT_APP_BASE_API_URL + 'Menu';

        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authToken,
            },
            body: JSON.stringify(p)
        });

        console.log(`Saving ${JSON.stringify(p)}`);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log(data);
    }

    const cancelEdit = () => {
        setEditingProductId(null);
    };

    return (
        <div className="container mt-5">
            <form className="form-inline" onSubmit={saveProduct}>
                <h2>Product {product.productNumber} - {product.productName}</h2>
                <div className='form-group mb-2'>
                    <label>Product Name:</label>
                    <input type="text" className="form-control" value={productName} onChange={(e) => setProductName(e.target.value)} />
                </div>
                <div className='form-group mb-2'>
                    <label>Description:</label>
                    <textarea className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div className='form-group mb-2'>
                    <label>Categories:</label>
                    <input type="text" className="form-control" value={categories} onChange={(e) => setCategories(e.target.value)} />
                    <small id="categoriesHelp" className="form-text text-muted"> Comma (,) seperated list of categories. </small>
                    <br />
                    <small id="categoriesHelp2" className="form-text text-muted"> Currently known categories: <br /> {categoryList.join(' , ')}
                    </small>
                </div>
                <div className='form-group mb-2'>
                    <label>Type:</label>
                    <input type="text" className="form-control" value={type} onChange={(e) => setType(e.target.value)} />
                    <small id="typesHelp" className="form-text text-muted"> One 'type' of product, usually the kind of beer. </small>
                    <br />
                    <small id="typesHelp2" className="form-text text-muted"> Currently known types: <br /> {typeList.join(' , ')} </small>
                </div>
                <div className='form-group mb-2'>
                    <label>Price:</label>
                    <input type="number" className="form-control" value={price} onChange={(e) => setPrice(e.target.value)} />
                </div>
                <div className='form-group mb-2'>
                    <label>Brewery:</label>
                    <input type="text" className="form-control" value={brouwer} onChange={(e) => setBrouwer(e.target.value)} />
                </div>
                <div>
                    <button type="submit" className="btn btn-primary">Save</button>
                    <button className="btn btn-secondary" onClick={cancelEdit}>Cancel</button>
                </div>
                {errorMessage && <p>{errorMessage}</p>}
            </form >
        </div >
    );
}

export default ProductEdit;